import { render, staticRenderFns } from "./siteDeployAdd.vue?vue&type=template&id=70f3e1a8&scoped=true"
import script from "./siteDeployAdd.vue?vue&type=script&lang=js"
export * from "./siteDeployAdd.vue?vue&type=script&lang=js"
import style0 from "./siteDeployAdd.vue?vue&type=style&index=0&id=70f3e1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f3e1a8",
  null
  
)

export default component.exports